<div #viewport class="viewport" (scroll)="onScroll($event)">
  <div
    #content
    class="content"
    [style.height]="totalContentHeight + 'px'"
    tsDragSelection
    [tsDragSelectionEnabled]="dragSelectionEnabled"
    [tsDragSelectionHitTester]="dragSelectionHitTester"
    [tsDragSelectionDelegate]="dragSelectionDelegate"
  >
    <div
      class="visible-nodes"
      [style.transform]="'translateY(' + offsetY + 'px)'"
    >
      <ng-container
        *ngFor="let item of visibleItems; let i = index; trackBy: trackByIndex"
      >
        <div
          #rowElement
          [style.padding]="gap / 2 + 'px'"
          [id]="i + startNode"
          class="row-item"
        >
          <ng-container
            *ngTemplateOutlet="
              rowTemplate;
              context: { $implicit: i + startNode }
            "
          ></ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
